var _style, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoTbLoading({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "18 52 484 396",
    className: "tb-loader",
    role: "img",
    "aria-label": "Carregando",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .tb-loader { overflow: visible; }\n    .tb-loader .br, .tb-loader .ln { fill: none; stroke-linecap: butt; stroke-linejoin: round;\n      stroke-dasharray: 1 1; stroke-dashoffset: 1; }\n    .tb-loader .br { stroke: #fff; }\n    .tb-loader .br.e0 { animation: tb-brush0 3s cubic-bezier(.65, 0, .35, 1) infinite both; }\n    .tb-loader .ln.e0 { animation: tb-line0 3s cubic-bezier(.65, 0, .35, 1) infinite both; }\n    .tb-loader .ln.tint.e0 { animation: tb-line0 3s cubic-bezier(.65, 0, .35, 1) infinite both, tb-tint 3s ease-in-out infinite both; }\n    .tb-loader .br.e1 { animation: tb-brush1 3s cubic-bezier(.65, 0, .35, 1) infinite both; }\n    .tb-loader .ln.e1 { animation: tb-line1 3s cubic-bezier(.65, 0, .35, 1) infinite both; }\n    .tb-loader .ln.tint.e1 { animation: tb-line1 3s cubic-bezier(.65, 0, .35, 1) infinite both, tb-tint 3s ease-in-out infinite both; }\n    .tb-loader .br.e2 { animation: tb-brush2 3s cubic-bezier(.65, 0, .35, 1) infinite both; }\n    .tb-loader .ln.e2 { animation: tb-line2 3s cubic-bezier(.65, 0, .35, 1) infinite both; }\n    .tb-loader .ln.tint.e2 { animation: tb-line2 3s cubic-bezier(.65, 0, .35, 1) infinite both, tb-tint 3s ease-in-out infinite both; }\n    .tb-loader .base { transform-box: fill-box; transform-origin: center;\n      animation: tb-base 3s cubic-bezier(.22, 1, .36, 1) infinite both; }\n    .tb-loader .shine { animation: tb-shine 3s ease-in-out infinite both; }\n    .tb-loader .logo { animation: tb-out 3s ease-in infinite both; }\n\n    /* 2\u201342% linhas finas desenham anel, T e B sobre fundo livre \xB7 36\u201352% selo azul surge\n       42\u201372% pincel pinta branco e vermelho \xB7 72\u201386% brilho \xB7 88\u201398% tudo sai junto */\n    @keyframes tb-line0 {\n      0%, 2% { stroke-dashoffset: 1; opacity: 1; }\n      26%, 60% { stroke-dashoffset: 0; opacity: 1; }\n      68%, 100% { stroke-dashoffset: 0; opacity: 0; }\n    }\n    @keyframes tb-brush0 {\n      0%, 42% { stroke-dashoffset: 1; }\n      60%, 98% { stroke-dashoffset: 0; }\n      100% { stroke-dashoffset: 1; }\n    }\n    @keyframes tb-line1 {\n      0%, 10% { stroke-dashoffset: 1; opacity: 1; }\n      34%, 66% { stroke-dashoffset: 0; opacity: 1; }\n      74%, 100% { stroke-dashoffset: 0; opacity: 0; }\n    }\n    @keyframes tb-brush1 {\n      0%, 48% { stroke-dashoffset: 1; }\n      66%, 98% { stroke-dashoffset: 0; }\n      100% { stroke-dashoffset: 1; }\n    }\n    @keyframes tb-line2 {\n      0%, 18% { stroke-dashoffset: 1; opacity: 1; }\n      42%, 72% { stroke-dashoffset: 0; opacity: 1; }\n      80%, 100% { stroke-dashoffset: 0; opacity: 0; }\n    }\n    @keyframes tb-brush2 {\n      0%, 54% { stroke-dashoffset: 1; }\n      72%, 98% { stroke-dashoffset: 0; }\n      100% { stroke-dashoffset: 1; }\n    }\n    @keyframes tb-base {\n      0%, 36% { opacity: 0; transform: scale(.92); }\n      52%, 100% { opacity: 1; transform: scale(1); }\n    }\n    /* navy guide lines turn white as the badge rises, so they stay visible on the blue */\n    @keyframes tb-tint {\n      0%, 38% { stroke: #14279f; }\n      50%, 100% { stroke: #ffffff; }\n    }\n    @keyframes tb-shine {\n      0%, 72% { transform: translateX(-260px); }\n      86%, 100% { transform: translateX(700px); }\n    }\n    @keyframes tb-out {\n      0%, 88% { opacity: 1; }\n      98%, 100% { opacity: 0; }\n    }\n    @media (prefers-reduced-motion: reduce) {\n      .tb-loader .br[class] { stroke-dashoffset: 0; animation: none; }\n      .tb-loader .ln[class], .tb-loader .shine { display: none; }\n      .tb-loader .base[class] { animation: none; }\n      .tb-loader .logo { animation: tb-pulse 1.6s ease-in-out infinite alternate; }\n      @keyframes tb-pulse { from { opacity: 1; } to { opacity: .5; } }\n    }\n  ")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "tbm-ring",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 520,
    height: 500
  }, /*#__PURE__*/React.createElement("path", {
    className: "br e0",
    pathLength: 1,
    strokeWidth: 48,
    d: "M259.7 78.55 A204.2 171.7 0 0 1 259.7 421.95 A204.2 171.7 0 0 1 259.7 78.55"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "tbm-t",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 520,
    height: 500
  }, /*#__PURE__*/React.createElement("path", {
    className: "br e1",
    pathLength: 1,
    strokeWidth: 90,
    d: "M58 175.5 H300 M202.9 150 L125.2 372"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "tbm-c-ring",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.7 69.45 A224 180.8 0 0 1 259.7 431.05 A224 180.8 0 0 1 259.7 69.45Z M259.7 87.65 A184.4 162.6 0 0 1 259.7 412.85 A184.4 162.6 0 0 1 259.7 87.65Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "tbm-c-t"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.49 150.5 L249.57 150.5 L285.27 200.5 L222.72 200.5 L170.22 350.5 L95.22 350.5 L147.72 200.5 L64.26 200.5 A204.2 171.7 0 0 1 93.49 150.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "tbm-c-in"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.7 87.65 A184.4 162.6 0 0 1 259.7 412.85 A184.4 162.6 0 0 1 259.7 87.65Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "tbm-c-b",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.57 150.5 L425.82 150.5 C446.81 150.5 457.87 167.51 450.52 188.5 L438.8 222 C435.3 232 426.8 242 404.95 253 C416.25 255 424.95 263 418.25 285 L407.57 315.5 C400.81 334.83 379.66 350.5 360.32 350.5 L220.52 350.5 L269.52 210.5 L323.52 210.5 L318.27 225.5 L377.57 225.5 C384.48 225.5 392.03 219.9 394.45 213 C396.87 206.1 393.23 200.5 386.32 200.5 L295.27 200.5 Z M296.57 275.5 L361.07 275.5 C369.57 275.5 371.8 282 368.48 291.5 C364.63 302.5 355 310 344 310 L284.5 310 Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "tbm-b",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 520,
    height: 500
  }, /*#__PURE__*/React.createElement("path", {
    className: "br e2",
    pathLength: 1,
    strokeWidth: 70,
    transform: "matrix(1 0 -0.35 1 87.5 0)",
    d: "M212 175.5 H369 A37.5 37.5 0 0 1 369 250.5 H296 M365 250.5 A40 40 0 0 1 365 330.5 H262 M282 358 V204"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "tbm-art",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.7 69.45 A224 180.8 0 0 1 259.7 431.05 A224 180.8 0 0 1 259.7 69.45Z M259.7 87.65 A184.4 162.6 0 0 1 259.7 412.85 A184.4 162.6 0 0 1 259.7 87.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.49 150.5 L249.57 150.5 L285.27 200.5 L222.72 200.5 L170.22 350.5 L95.22 350.5 L147.72 200.5 L64.26 200.5 A204.2 171.7 0 0 1 93.49 150.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.57 150.5 L425.82 150.5 C446.81 150.5 457.87 167.51 450.52 188.5 L438.8 222 C435.3 232 426.8 242 404.95 253 C416.25 255 424.95 263 418.25 285 L407.57 315.5 C400.81 334.83 379.66 350.5 360.32 350.5 L220.52 350.5 L269.52 210.5 L323.52 210.5 L318.27 225.5 L377.57 225.5 C384.48 225.5 392.03 219.9 394.45 213 C396.87 206.1 393.23 200.5 386.32 200.5 L295.27 200.5 Z M296.57 275.5 L361.07 275.5 C369.57 275.5 371.8 282 368.48 291.5 C364.63 302.5 355 310 344 310 L284.5 310 Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tbm-glint",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fff",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "logo"
  }, /*#__PURE__*/React.createElement("path", {
    className: "base",
    fill: "#14279f",
    d: "M259.7 56.25 A238 194 0 0 1 259.7 444.25 A238 194 0 0 1 259.7 56.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    mask: "url(#tbm-ring)",
    fill: "#ffffff",
    fillRule: "evenodd",
    d: "M259.7 69.45 A224 180.8 0 0 1 259.7 431.05 A224 180.8 0 0 1 259.7 69.45Z M259.7 87.65 A184.4 162.6 0 0 1 259.7 412.85 A184.4 162.6 0 0 1 259.7 87.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    mask: "url(#tbm-t)",
    fill: "#ffffff",
    d: "M93.49 150.5 L249.57 150.5 L285.27 200.5 L222.72 200.5 L170.22 350.5 L95.22 350.5 L147.72 200.5 L64.26 200.5 A204.2 171.7 0 0 1 93.49 150.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    mask: "url(#tbm-b)",
    fill: "#e80f18",
    fillRule: "evenodd",
    d: "M259.57 150.5 L425.82 150.5 C446.81 150.5 457.87 167.51 450.52 188.5 L438.8 222 C435.3 232 426.8 242 404.95 253 C416.25 255 424.95 263 418.25 285 L407.57 315.5 C400.81 334.83 379.66 350.5 360.32 350.5 L220.52 350.5 L269.52 210.5 L323.52 210.5 L318.27 225.5 L377.57 225.5 C384.48 225.5 392.03 219.9 394.45 213 C396.87 206.1 393.23 200.5 386.32 200.5 L295.27 200.5 Z M296.57 275.5 L361.07 275.5 C369.57 275.5 371.8 282 368.48 291.5 C364.63 302.5 355 310 344 310 L284.5 310 Z"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#tbm-c-ring)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ln e0 tint",
    pathLength: 1,
    stroke: "#14279f",
    strokeWidth: 6,
    d: "M259.7 69.45 A224 180.8 0 0 1 259.7 431.05 A224 180.8 0 0 1 259.7 69.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ln e0 tint",
    pathLength: 1,
    stroke: "#14279f",
    strokeWidth: 6,
    d: "M259.7 87.65 A184.4 162.6 0 0 1 259.7 412.85 A184.4 162.6 0 0 1 259.7 87.65Z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#tbm-c-t)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#tbm-c-in)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ln e1 tint",
    pathLength: 1,
    stroke: "#14279f",
    strokeWidth: 6,
    d: "M93.49 150.5 L249.57 150.5 L285.27 200.5 L222.72 200.5 L170.22 350.5 L95.22 350.5 L147.72 200.5 L64.26 200.5 A204.2 171.7 0 0 1 93.49 150.5Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#tbm-c-b)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ln e2",
    pathLength: 1,
    stroke: "#e80f18",
    strokeWidth: 6,
    d: "M259.57 150.5 L425.82 150.5 C446.81 150.5 457.87 167.51 450.52 188.5 L438.8 222 C435.3 232 426.8 242 404.95 253 C416.25 255 424.95 263 418.25 285 L407.57 315.5 C400.81 334.83 379.66 350.5 360.32 350.5 L220.52 350.5 L269.52 210.5 L323.52 210.5 L318.27 225.5 L377.57 225.5 C384.48 225.5 392.03 219.9 394.45 213 C396.87 206.1 393.23 200.5 386.32 200.5 L295.27 200.5 Z M296.57 275.5 L361.07 275.5 C369.57 275.5 371.8 282 368.48 291.5 C364.63 302.5 355 310 344 310 L284.5 310 Z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#tbm-art)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "skewX(-20)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "shine",
    x: 0,
    y: 40,
    width: 110,
    height: 420,
    fill: "url(#tbm-glint)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTbLoading);
export default __webpack_public_path__ + "static/media/logo-tb-loading.3aa1bb076aba49165af0ba9bb1ef11f3.svg";
export { ForwardRef as ReactComponent };